function formatWaveCreatedOn(value)
{
	if (value == null || value === '')
		return '';
	let s = String(value).trim();
	if (/^\d{4}-\d{2}-\d{2} /.test(s))
		s = s.replace(' ', 'T');
	const d = new Date(s);
	if (Number.isNaN(d.getTime()))
		return String(value);
	const pad = (n) => String(n).padStart(2, '0');
	return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} - ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

export default async function (records)
{
	const rows = Array.isArray(records) ? records : [];
	return `
		<style>
			.view th:nth-child(1) { width: 1rem; }
			.view td:nth-child(3),
			.view td:nth-child(4),
			.view td:nth-child(5),
			.view td:nth-child(6),
			.view td:nth-child(7) { text-align: right; }
			.pw-exc { color: #a30; }
			.view tr[data-id] { cursor: pointer; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">Onda</th>
					<th data-index="2" data-visible="${this.visible[2]}">Pedidos</th>
					<th data-index="3" data-visible="${this.visible[3]}">Descer pend.</th>
					<th data-index="4" data-visible="${this.visible[4]}">Descer ok</th>
					<th data-index="5" data-visible="${this.visible[5]}">Exceções</th>
					<th data-index="6" data-visible="${this.visible[6]}">Status</th>
					<th data-index="7" data-visible="${this.visible[7]}">Criação</th>
				</tr>
			</thead>
			<tbody>
				${rows.map((r) => `
					<tr data-id='${JSON.stringify([r.company_id, r.id])}'>
						<td><input type="checkbox"></td>
						<td>${r.company_nick || r.company_id || ''}</td>
						<td>${r.id ?? ''}</td>
						<td>${r.order_count ?? ''}</td>
						<td>${r.descer_pending ?? ''}</td>
						<td>${r.descer_done ?? ''}</td>
						<td class="${Number(r.exception_count) > 0 ? 'pw-exc' : ''}">${r.exception_count ?? ''}</td>
						<td>${({
							DRAFT: 'Rascunho', CONFIRMED: 'Confirmada', DESCENDING: 'Descendo',
							PICKING: 'Separação', RETURNING: 'Devolvendo', DONE: 'Concluída',
							EXCEPTION: 'Exceção', CANCELLED: 'Cancelada',
						}[r.status] || r.status || '')}</td>
						<td>${formatWaveCreatedOn(r.created_on)}</td>
					</tr>
				`).join('')}
			</tbody>
		</table>
	`;
}
